/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{color:#1c5ab9;text-decoration:none}a[_ngcontent-%COMP%]:hover{text-decoration:underline}.modal[_ngcontent-%COMP%]{display:flex;align-items:flex-end;flex-direction:column}.modal__close[_ngcontent-%COMP%]{cursor:pointer;color:#283853}.content[_ngcontent-%COMP%]{width:640px;position:relative;margin:auto;display:flex;flex-direction:column;align-items:center;padding:40px;text-align:center}@media (max-width:1024px){.content[_ngcontent-%COMP%]{width:100%}}"];
export { styles as styles };
